<section class="contractors">
  <div class="heading">
    <h4>{{ `${I18N}.heading` | translate }} {{ order().identifier }}</h4>

    <p class="f-body-2xs f-muted">
      {{ 'labels.issued' | translate }} {{ today | onyxDate: 'time-dot-date' }}
    </p>
  </div>

  <div class="container">
    <div class="item">
      <p class="f-body-2xs f-medium f-muted">
        {{ 'labels.principal' | translate | uppercase }}
      </p>

      <div class="details">
        <p class="f-body-s f-medium">{{ business.companyName }}</p>

        <p class="f-body-xs">
          {{ 'labels.vatId' | translate }}: {{ business.country | uppercase
          }}{{ business.vatId }}
        </p>

        <onyx-address
          class="f-body-xs f-muted"
          [address]="business!.mainAddress"
          format="pdf"
        ></onyx-address>
      </div>
    </div>

    <div class="item">
      <p class="f-body-2xs f-medium f-muted">
        {{ 'labels.serviceProvider' | translate | uppercase }}
      </p>

      @let outsourcingData = this.order().outsourcingData;
      @if (contractor$() | async; as contractor) {
        <div class="details">
          @let companyProfile = contractor.companyProfile;
          <p class="f-body-s f-medium">{{ companyProfile.companyName }}</p>

          <p class="f-body-xs">
            {{ 'labels.vatId' | translate }}:
            {{ companyProfile.country | uppercase }}{{ companyProfile.vatId }}
          </p>

          <onyx-address
            class="f-body-xs f-muted"
            [address]="contractor.companyData!.mainAddress"
            format="pdf"
          ></onyx-address>
        </div>
      }

      @if (outsourcingData?.contactPerson; as contactPerson) {
        <div class="details">
          <p class="f-body-s f-medium">
            {{ contactPerson | onyxName }}
          </p>

          <p class="f-body-xs">
            {{ contactPerson.phone | onyxPhone }}
          </p>
        </div>
      }
    </div>
  </div>
</section>
